import axios from "axios";
import { getToken } from "../../users/services/localStorage";

const apiUrl = process.env.REACT_APP_API_URL || "http://10.0.0.27:8181";
const API_URL = `${apiUrl}/api/coupons`;

// Get auth headers
const getAuthHeaders = () => ({
  "x-auth-token": getToken(),
});

// Admin API calls
export const createCoupon = async (couponData: any) => {
  const response = await axios.post(API_URL, couponData, {
    headers: getAuthHeaders(),
  });
  return response.data;
};

export const getAllCoupons = async () => {
  const response = await axios.get(API_URL, {
    headers: getAuthHeaders(),
  });
  return response.data;
};

export const getCouponById = async (id: string) => {
  const response = await axios.get(`${API_URL}/${id}`, {
    headers: getAuthHeaders(),
  });
  return response.data;
};

export const updateCoupon = async (id: string, couponData: any) => {
  const response = await axios.put(`${API_URL}/${id}`, couponData, {
    headers: getAuthHeaders(),
  });
  return response.data;
};

export const deleteCoupon = async (id: string) => {
  const response = await axios.delete(`${API_URL}/${id}`, {
    headers: getAuthHeaders(),
  });
  return response.data;
};

export const toggleCouponStatus = async (id: string) => {
  const response = await axios.patch(
    `${API_URL}/${id}/toggle`,
    {},
    {
      headers: getAuthHeaders(),
    }
  );
  return response.data;
};

// Public API call
export const validateCoupon = async (code: string) => {
  const response = await axios.post(`${API_URL}/validate`, { code });
  return response.data;
};
